import { render } from "./Ma_BusLayoutAdmin.vue?vue&type=template&id=78d18b4f&scoped=true"
import script from "./Ma_BusLayoutAdmin.vue?vue&type=script&lang=js"
export * from "./Ma_BusLayoutAdmin.vue?vue&type=script&lang=js"

import "./Ma_BusLayoutAdmin.vue?vue&type=style&index=0&id=78d18b4f&scoped=true&lang=css"

import exportComponent from "D:\\curProject\\newTrip\\client\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78d18b4f"]])

export default __exports__